"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => ({
    root: {
        boxSizing: 'border-box',
        width: '100%',
        height: constants_1.HEADER_HEIGHT,
        backgroundColor: theme.grey9,
        position: 'fixed',
        zIndex: constants_1.HEADER_FIXED_ZINDEX,
        top: 0,
        left: 0,
        right: 0,
        paddingTop: 'env(safe-area-inset-top)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)'
    }
});
//# sourceMappingURL=kanban.header.style.js.map